<template>
  <v-app>
   
  <InteractiveMap/>

   
  </v-app>
</template>

<script>
import InteractiveMap from './components/InteractiveMap.vue';

export default {
  name: 'App',

  components: {
    InteractiveMap
  },

  data: () => ({
    //
    
  }),
};
</script>
